export function initMarquee() {
    const marquees = document.querySelectorAll('.company-marquee');
    for (const marquee of marquees) {
        const section = marquee.querySelector('.company-marquee-section');
        const inner = section.querySelector('.company-marquee-inner');

        const innerRect = inner.getBoundingClientRect();
        const duplicates = Math.ceil(window.innerWidth / innerRect.width) - 1;

        for (let i = 0; i < duplicates; i++) {
            const clone = inner.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            section.appendChild(clone);
        }

        const sectionClone = section.cloneNode(true);
        sectionClone.setAttribute('aria-hidden', 'true');
        marquee.appendChild(sectionClone);
        marquee.classList.add('company-marquee--started');
    }
}